interface CustomCurrency {
  sign: string
  useIntlCurrencyStyle: boolean
  isFiat: boolean
}

// TODO: remove after base currency select
const customCurrencies: Record<string, CustomCurrency | undefined> = {
  BAM: {
    sign: 'KM',
    useIntlCurrencyStyle: false,
    isFiat: true,
  },
  KM: {
    sign: 'KM',
    useIntlCurrencyStyle: false,
    isFiat: true,
  },
}

export const findCustomCurrency = (currencyCode?: string) => {
  if (!currencyCode) {
    return
  }

  return customCurrencies[currencyCode.toUpperCase()]
}
